import { useCallback } from 'react';
import { fetchUserById, fetchUserSuccess } from '@Redux/actions';
import { useSelector, useDispatch } from 'react-redux';
import { useReduxActiveUser } from '@Hooks/reduxActiveUserHook/useReduxActiveUser';

export const useReduxUsers = (time = 3600000) => {

    const dispatch = useDispatch();
    const { activeUserId, activeUser } = useReduxActiveUser();
    const users = useSelector((state) => state.user.users);

    const setUsersAndCatch = useCallback(
        async (id) => dispatch(fetchUserById(id)),
        [dispatch]
    );

    const getUserById = async(id)=> {
        if(activeUserId === id) {
            return activeUser;
        }
        let response;
        if(!!users) {
            if(!!users[id]) {
                return JSON.parse(users[id]?.body);
            } else {
               response = await setUsersAndCatch(id);
               return JSON.parse(response.body);
            }
        } else {
           response = await setUsersAndCatch(id);
           return JSON.parse(response.body);
        }
    }

    const setUpdateUser = useCallback(
        async (id, data) => dispatch(fetchUserSuccess(id, data)),
        [dispatch]
    );

    return {
        allUsers: users,
        getUserByIdAndFetch : getUserById,
        setUpdateUser: setUpdateUser,
        setUsersAndCatch: setUsersAndCatch,
    }
}